// extracted by mini-css-extract-plugin
module.exports = {"translationLanguage":"appointments__TranslationLanguage__translationLanguage","disabled":"appointments__TranslationLanguage__disabled"};